import { programTypeMapper } from "@tailormed/common-client/util/programTypeMapping";
import _ from "lodash";
import { formatPapRxnormDrugName, formatPapRxnormDrugNameFriendly, isPackRxnormDrug } from "./drugs";

export function getPotentialSavingMatchedDrugs(potentialSaving, journey) {
  const patientEligibleIds = potentialSaving.patientEligibleRxnormDrugs;
  if (!patientEligibleIds?.length) return;

  const journeyDrugs = (journey?.events || [])
    .flatMap((event) => event.drugEntries || [])
    .map((entry) => entry.rxnormDrug)
    .filter(Boolean);

  const directlyMatchedDrugs = journeyDrugs.filter((drug) => patientEligibleIds.includes(drug.id));

  // If any matched drug is a pack, also include non-pack patient drugs sharing the pack's
  // ingredient. Mirrors the auto-populate saga's behavior where a matched pack pulls in the
  // patient's separate ingredient-level drug via /bn-pin-drugs' pack-to-PIN fallback.
  const packMatchedPinCuis = new Set(
    directlyMatchedDrugs
      .filter(isPackRxnormDrug)
      .map((drug) => drug.pinCui)
      .filter(Boolean)
  );
  const ingredientSiblingDrugs = journeyDrugs.filter(
    (drug) => !isPackRxnormDrug(drug) && packMatchedPinCuis.has(drug.pinCui)
  );

  const matchedPatientDrugs = _.uniqBy([...directlyMatchedDrugs, ...ingredientSiblingDrugs], "id");
  const names = [...new Set(matchedPatientDrugs.map(formatPapRxnormDrugNameFriendly).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b)
  );
  if (!names.length) return;

  return names.join(", ");
}

export function getPotentialSavingDisplayName(potentialSaving, journey) {
  const { name } = potentialSaving;
  let displayName = name;
  let drugName;
  const currentApplication = potentialSaving.applications.find((app) => app.id === potentialSaving.currentApplication);

  if (
    programTypeMapper.isManufacturerProgram(potentialSaving) ||
    programTypeMapper.isManufacturerFreeDrugProgram(potentialSaving)
  ) {
    const drug = potentialSaving.apEligibleRxnormDrugs?.[0];
    drugName = drug && isPackRxnormDrug(drug) ? formatPapRxnormDrugName(drug) : potentialSaving.drugDisplayName;
  } else if (programTypeMapper.isFoundationProgram(potentialSaving)) {
    const junctionDrugs = currentApplication?.assistanceProgramApplicationDrugs;
    if (junctionDrugs?.length) {
      // Re-derive at render so packs collapse to friendly tmDisplayName,
      // independent of what's in the persisted associatedDrugs strings.
      const names = [
        ...new Set(junctionDrugs.map((d) => formatPapRxnormDrugNameFriendly(d.rxnormDrug ?? d)).filter(Boolean))
      ].sort((a, b) => a.localeCompare(b));
      drugName = names.join(", ") || undefined;
    } else {
      drugName = getPotentialSavingMatchedDrugs(potentialSaving, journey);
    }
  }

  if (drugName && !currentApplication?.hideAssociatedDrugs) {
    displayName = `${name} (${drugName})`;
  }
  return { displayName, drugName };
}
